import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import SharedAuth0Provider from "@shared/auth/Auth0Provider";
import { onAuth0Redirect } from "@shared/auth/redirects";
import { useAuth0RemergeApi } from "@shared/auth/useAuth0RemergeApi";
import { theme } from "@shared/designSystem/theme";
import { RemergeAPIProvider } from "@shared/http/remergeApiContext";
import { TrackingProvider } from "@shared/services/TrackingContext";
import trackingService from "@sherlock-ui/services/tracking";
type AppContextProps = React.PropsWithChildren<{}>;

export default function AppContext(props: AppContextProps) {
  return (
    <SharedAuth0Provider onRedirectCallback={onAuth0Redirect}>
      <AppContextInner>{props.children}</AppContextInner>
    </SharedAuth0Provider>
  );
}

function AppContextInner({ children }: { children: React.ReactNode }) {
  const { remergeApi } = useAuth0RemergeApi({ apiHost: import.meta.env.VITE_API_HOST as string });

  return (
    <RemergeAPIProvider value={remergeApi}>
      <TrackingProvider value={trackingService}>
        <ThemeProvider theme={theme}>
          <StyledEngineProvider injectFirst>{children}</StyledEngineProvider>
        </ThemeProvider>
      </TrackingProvider>
    </RemergeAPIProvider>
  );
}
